import React from "react";

const AddIconForImgesUpload = () => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.56497 19.0014H32.435"
        stroke="white"
        stroke-width="2.85"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19 32.4365V5.56641"
        stroke="white"
        stroke-width="2.85"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AddIconForImgesUpload;
